import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Procedures: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Rect x={9} y={9} width={42} height={42} rx={6} fill="#fff" stroke={props.color} strokeWidth={2} />
            <Path
                d="M32 21.5a.5.5 0 01.5.5v3a1.5 1.5 0 001.5 1.5h3a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-3a1.5 1.5 0 00-1.5 1.5v3a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-3a1.5 1.5 0 00-1.5-1.5h-3a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h3a1.5 1.5 0 001.5-1.5v-3a.5.5 0 01.5-.5h4z"
                fill="#fff"
                stroke={props.color}
            />
        </Svg>
    );
};

export default React.memo(Procedures);
